
import React from 'react';
import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';
import { ThemeProvider } from '../theme/ThemeProvider';

interface MainLayoutProps {
  children: React.ReactNode;
  showSidebar?: boolean;
}

export function MainLayout({ children, showSidebar = false }: MainLayoutProps) {
  return (
    <ThemeProvider>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <div className="flex-1 flex">
          {showSidebar && (
            <div className="hidden md:block w-64 shrink-0">
              <Sidebar />
            </div>
          )}
          <main className="flex-1 pt-16">
            {children}
          </main>
        </div>
        <Footer />
      </div>
    </ThemeProvider>
  );
}
